import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMinimizeMode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17 8.25C16.3096 8.25 15.75 7.69036 15.75 7V4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4V7C14.25 8.51878 15.4812 9.75 17 9.75H20C20.4142 9.75 20.75 9.41421 20.75 9C20.75 8.58579 20.4142 8.25 20 8.25H17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 17C8.25 16.3096 7.69036 15.75 7 15.75H4C3.58579 15.75 3.25 15.4142 3.25 15C3.25 14.5858 3.58579 14.25 4 14.25H7C8.51878 14.25 9.75 15.4812 9.75 17V20C9.75 20.4142 9.41421 20.75 9 20.75C8.58579 20.75 8.25 20.4142 8.25 20V17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 17C15.75 16.3096 16.3096 15.75 17 15.75H20C20.4142 15.75 20.75 15.4142 20.75 15C20.75 14.5858 20.4142 14.25 20 14.25H17C15.4812 14.25 14.25 15.4812 14.25 17V20C14.25 20.4142 14.5858 20.75 15 20.75C15.4142 20.75 15.75 20.4142 15.75 20V17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 7C8.25 7.69036 7.69036 8.25 7 8.25H4C3.58579 8.25 3.25 8.58579 3.25 9C3.25 9.41421 3.58579 9.75 4 9.75H7C8.51878 9.75 9.75 8.51878 9.75 7V4C9.75 3.58579 9.41421 3.25 9 3.25C8.58579 3.25 8.25 3.58579 8.25 4V7Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconMinimizeMode as ReactComponent };
